import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { orderService } from 'services/api';
import { IPurchaseOrder } from 'interfaces';

interface InfoBoxTransportActiveDocumentCardProps {
  order_id: string | number;
}

/**
 * Componente per visualizzazione informazioni relative all'ordine del documento di trasporto.
 */
export default function InfoBoxTransportActiveDocumentCard(
  params: InfoBoxTransportActiveDocumentCardProps
) {
  const { order_id } = params;
  const { t } = useTranslation();
  const translationPrefix = 'pages.transport-active-document.box-info';
  const [order, setOrder] = useState<IPurchaseOrder | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    orderService.get(order_id).then(setOrder);
  }, []);

  useEffect(() => {
    if (!order?.id) return;
    setLoading(false);
  }, [order?.id]);

  return (
    <>
      <Card
        style={{
          width: '100%',
          height: '100%',
          maxHeight: '360px',
          padding: '2px',
          overflowY: 'scroll'
        }}>
        <CardContent>
          {!loading && (
            <div id="Order Details">
              <Typography id="Titolo" variant="h5" component="div" color="primary" sx={{ mb: 1 }}>
                {t(`${translationPrefix}.details`)} <b>{order.ref}</b>
              </Typography>
              <br />
              <Typography id="Descrizione" component="div" sx={{ mb: 1 }}>
                {order.ref + ' - ' + order.supplier}
              </Typography>
              <br />
              <Box id="Lista righe ordine" component="div" sx={{ whiteSpace: 'pre-line' }}>
                <Divider light variant="middle" component="div">
                  <b>{t(`${translationPrefix}.order-lines`)}</b>
                </Divider>
                <br />
                {order.lines?.map((line) => (
                  <Box key={line.id} sx={{ mb: 1, p: 1 }}>
                    {t(`${translationPrefix}.order-lines-description`, {
                      product_description: line.product.code + ' - ' + line.product.description,
                      initial_qty: line.initial_quantity,
                      remaining_qty: line.remaining_quantity
                    })}
                  </Box>
                ))}
              </Box>
            </div>
          )}
        </CardContent>
      </Card>
    </>
  );
}
